module.exports = __webpack_public_path__ + "img/d88b8bc.jpg";